module.exports = __webpack_public_path__ + "img/yesterday.bf5c18ca.svg";